import { defineMessages } from 'react-intl'

export const strings = defineMessages({
  copyright: {
    id: 'AppLayout.copyright',
    defaultMessage: '© {date} Clowdbuster Studio LLC',
  },
  menuAlt: {
    id: 'AppLayout.menuAlt',
    defaultMessage: 'Menu',
  },
  logoAlt: {
    id: 'AppLayout.logoAlt',
    defaultMessage: 'Party Guestbook',
  },
  AccountLink: {
    id: 'AppLayout.AccountLink',
    defaultMessage: 'Account',
  },
  DashboardLink: {
    id: 'AppLayout.DashboardLink',
    defaultMessage: 'Dashboard',
  },
  settingsLink: {
    id: 'AppLayout.settingsLink',
    defaultMessage: 'Settings',
  },
  contactLink: {
    id: 'AppLayout.contactLink',
    defaultMessage: 'Contact',
  },
  pricingLink: {
    id: 'AppLayout.pricingLink',
    defaultMessage: 'Pricing',
  },
  signInLink: {
    id: 'AppLayout.signInLink',
    defaultMessage: 'Sign in',
  },
  LogoutBtn: {
    id: 'AppLayout.LogoutBtn',
    defaultMessage: 'Logout',
  },
  signoutBtn: {
    id: 'AppLayout.signoutBtn',
    defaultMessage: 'Sign out',
  },
  termsOfUse: {
    id: 'AppLayout.termsOfUse',
    defaultMessage: 'Terms of Service',
  },
  privacyPolicy: {
    id: 'AppLayout.privacyPolicy',
    defaultMessage: 'Privacy Policy',
  },
})
